module.exports = __webpack_public_path__ + "static/img/logo555.eaa750f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/logo555.png
// module id = iQ8z
// module chunks = 76